import { useContext } from 'react';

import { ReferenceContext } from 'src/components/contexts/ReferenceContext/ReferenceContext.context';
import type { IProductSpecificationReference } from 'src/types/reference/IProductSpecificationReference';

export function useProductTypeCustomerLeadSpecification(
  productTypeId?: string | null
): IProductSpecificationReference | null {
  const { productTypesRecord, productSpecificationsRecord } = useContext(ReferenceContext);

  return productTypeId != null
    ? productSpecificationsRecord[productTypesRecord[productTypeId].customerLeadSpecId]
    : null;
}
